import {
  BasicButton,
  ButtonGroup,
  LegacyModal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  PrimaryButton,
  Text,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";
import { useOverlayTriggerState } from "react-stately";

type SkipVerificationModalProps = {
  show: boolean;
  onClose: () => void;
  handleSkipVerification: () => void;
};

export function SkipVerificationModal({
  show,
  onClose,
  handleSkipVerification,
}: SkipVerificationModalProps) {
  const { t } = useTranslation();
  const modalState = useOverlayTriggerState({});

  if (!show) {
    return null;
  }

  return (
    <ModalOverlay state={modalState}>
      <LegacyModal width="456px">
        <ModalHeader close={onClose} title={t("Skip Identity Verification")} />

        <ModalContent>
          <Text style="global/body-primary">
            <Trans>
              You can skip identity verification for now and proceed with your
              application. After submission, one of our representatives will
              contact you to verify your identity. If you choose to verify your
              identity later, it may delay your application process.
              <br />
              <br />
              If skipped, this step will be completed and you cannot change your
              decision after.
            </Trans>
          </Text>
        </ModalContent>

        <ModalFooter>
          <ButtonGroup>
            <BasicButton size="medium" onPress={onClose}>
              <Trans>Go back</Trans>
            </BasicButton>
            <PrimaryButton size="medium" onPress={handleSkipVerification}>
              <Trans>Skip Verification</Trans>
            </PrimaryButton>
          </ButtonGroup>
        </ModalFooter>
      </LegacyModal>
    </ModalOverlay>
  );
}
